import { addClassName } from '@hc-frontend/core-utils-format';

import { useSubsidyCalculator } from './provider';

type StepIndicatorStatus = 'idle' | 'active' | 'completed';

type StepIndicatorProps = {
  number: number;
  label: string;
};

export function StepIndicator({ number, label }: StepIndicatorProps) {
  const { step } = useSubsidyCalculator();

  let status: StepIndicatorStatus = 'idle';
  const zeroBasedNumber = number - 1;

  if (step === zeroBasedNumber) {
    status = 'active';
  }

  if (step > zeroBasedNumber) {
    status = 'completed';
  }

  return (
    <div className="flex justify-center items-center flex-col bg-gray-0 z-10">
      <p
        className={addClassName(
          'hc-typography--paragraph-md rounded-full size-[32px] flex items-center justify-center font-bold transition-all',
          status === 'completed' ? 'bg-accent-800 text-gray-0' : '',
          status === 'active' ? 'bg-secondary-900 text-gray-0' : '',
          status === 'idle' ? 'bg-primary-50 text-primary-900' : '',
        )}
      >
        {number}
      </p>
      <p className="hc-typography--help-text mt-8-8">{label}</p>
    </div>
  );
}
